import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('tr', {
    class: [_vm.removing ? 'removing row-body' : 'row-body']
  }, [_c('td', {
    staticClass: "cell-checkbox text-center"
  }, [_c(VIcon, {
    attrs: {
      "color": _vm.color,
      "small": ""
    }
  }, [_vm._v("fas " + _vm._s(_vm.isImage ? 'fa-file-image' : 'fa-file'))])], 1), _c('td', {
    staticClass: "cell-name text-truncate",
    staticStyle: {
      "max-width": "1px"
    }
  }, [_c('span', {
    attrs: {
      "title": _vm.item.name
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.getAttachmentDownloadUrl(_vm.item),
      "target": "_blank",
      "download": ""
    }
  }, [_vm._v(_vm._s(_vm.item.name))])])]), _vm.$vuetify.breakpoint.smAndUp ? _c('td', {
    staticClass: "cell-size"
  }, [_c('span', [_vm._v(_vm._s(_vm.readableFileSizeFromBytes(_vm.item.size)))])]) : _vm._e(), _vm.item.file || _vm.isQueued ? _c('td', {
    staticClass: "cell-actions"
  }, [_c(VProgressCircular, {
    attrs: {
      "value": _vm.uploadProgress,
      "indeterminate": _vm.uploadProgress === 100,
      "rotate": 90,
      "size": "28",
      "width": "3"
    }
  })], 1) : _vm._e(), !_vm.item.file && !_vm.isQueued ? _c('td', {
    staticClass: "cell-actions"
  }, [_vm.isPreviewable(_vm.item.name) ? [_c(VIcon, {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.previewAttachment(_vm.item);
      }
    }
  }, [_vm._v("fal fa-eye")]), _vm._v("\n       \n    ")] : _vm._e(), _c('a', {
    attrs: {
      "disabled": _vm.removing,
      "href": _vm.getAttachmentDownloadUrl(_vm.item),
      "target": "_blank",
      "download": ""
    }
  }, [_c(VIcon, {
    attrs: {
      "small": "",
      "color": "primary"
    }
  }, [_vm._v("fal fa-arrow-circle-down")])], 1), _vm._v("\n     \n    "), _vm.deletable ? _c(VIcon, {
    attrs: {
      "color": _vm.color,
      "small": "",
      "disabled": _vm.disabled || _vm.removing
    },
    on: {
      "click": function ($event) {
        return _vm.deleteAttachment(_vm.item);
      }
    }
  }, [_vm._v("\n      fal fa-trash-alt\n    ")]) : _vm._e()], 2) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };